<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import ManageGroupView from "@/components/product-properties/product-groups/manageGroupView.vue";

/**
 * Starter component
 */
export default {
    page: {
        title: "Manage Product Group",
        meta: [{ name: "description", content: appConfig.description }],
    },
    components: { Layout, PageHeader, ManageGroupView },
    data() {
        return {
            title: "Manage Product Group",
            // items: [
            //     {
            //         text: "Dashboard",
            //         href: "/",
            //     },
            //     {
            //         text: "Properties",
            //         active: true,
            //     },
            // ],
        };
    },
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" />
        <ManageGroupView />
    </Layout>
</template>
